<template>
  <modal
    class="createAssetGroup"
    name="recordService"
    transition="pop-out"
    :width="800"
    :height="580"
  >
    <div class="text-center assets_modal_div branch_assets_modal">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">
        {{ $t("text.recordService.recordService") }}
      </p>
      <form>
        <div class="modal_form_field bas">
          <label class="assets_label required">{{
            $t("text.recordService.dateServiced")
          }}</label>
          <vue-ctk-date-time-picker
            v-model="dateServiced"
            :onlyDate="true"
            :autoClose="true"
            color="#370f70"
            format="DDMMYYYY"
            formatted="DD/MM/YYYY"
            class="assets_date_picker"
            :label="$t('text.calendar.dateRange')"
          />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label required">{{
            $t("text.recordService.nextServiceDate")
          }}</label>
          <vue-ctk-date-time-picker
            v-model="nextServiceDate"
            :onlyDate="true"
            :autoClose="true"
            color="#370f70"
            format="DDMMYYYY"
            formatted="DD/MM/YYYY"
            class="assets_date_picker"
            :label="$t('text.calendar.dateRange')"
          />
        </div>
        <div class="modal_form_field bas">
          <label class="assets_label">{{
            $t("text.recordService.note")
          }}</label>
          <textarea v-model="note" rows="3" class="modal_textarea"></textarea>
        </div>
        <button @click="record($event)" class="assets_button bas">
          {{ $t("text.recordService.recordService") }}
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="20px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "recordService",
  props: ["recordId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      dateServiced: null,
      nextServiceDate: null,
      note: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("recordService");
    },
    record(e) {
      e.preventDefault();
      if (!this.dateServiced) {
        this.$toast.open({
          message: this.$t("text.recordService.chooseServiceDate"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.nextServiceDate) {
        this.$toast.open({
          message: this.$t("text.recordService.chooseNextServiceDate"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        dateServiced: "2021-03-01",
        nextServiceDate: "2021-03-01",
        note: this.note,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Assets/${this.recordId}/record-service`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.$toast.open({
            message: this.$t("text.recordService.serviceRecorded"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("refreshBranchAssets");
          this.closeModal();
        })
        .catch((e) => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
